import Stickyfill from "stickyfilljs";
import { Controller } from "stimulus";

export default class extends Controller {
    connect() {
        Stickyfill.add(this.element);
    }
}


// WEBPACK FOOTER //
// ./mysite/resources/js/controllers/sticky_controller.js